const substituteEncodedCharacters = require('./substituteEncodedCharacters')
const proseInlineStyle = require('./proseInlineStyle')
const xmlBoilerplate = require('./setupXML')

function FDXconverter (data, mode) {
  const isProse = mode === 'PROSE_TO_FDX'
  const { xml, script } = xmlBoilerplate(data, mode)

  for (let i = script.length - 1; i > -1; i--) {
    const token = script[i]

    token.text = isProse
      ? proseInlineStyle(token.content, mode)
      : substituteEncodedCharacters(token.text, mode)

    // empty blocks, ie: { type: "action" }, { type: "dual_dialogue_begin" } are allowed
    token.text = `<Text>${token.text || ''}</Text>`

    let extraProps = ''

    // force a new page when necessary
    if (isProse && token.startsNewPage) {
      extraProps = ' StartsNewPage="Yes"'
    }

    if (isProse && token.attrs) {
      // pass through element numbers 'as is'
      if (token.attrs.elementNumber != null) {
        extraProps += ` Number="${token.attrs.elementNumber}"`
      }
      // custom alignment info needs capitalized
      if (token.attrs.alignment) {
        extraProps += ` Alignment="${token.attrs.alignment.charAt(0).toUpperCase() + token.attrs.alignment.slice(1)}"`
      }
    }

    switch (token.type) {
    // TODO : ADD Title Page Styling
      // case 'title':
      //   // title_page.push(`<h1><Text>${token.text}</Text></h1>`)
      //   if (title) {
      //     title = token.text.replace('<br />', ' ').replace(/<(?:.|)*?>/g, '')
      //   }
      //   break
      // case 'credit':
      //   title_page.push(`<p class=\"credit\"><Text>${token.text}</Text></p>`)
      //   break
      // case 'author':
      //   title_page.push(`<p class=\"authors\"><Text>${token.text}</Text></p>`)
      //   break
      // case 'authors':
      //   title_page.push('<p class=\"authors\"><Text>${token.text}</Text></p>')
      //   break
      // case 'source':
      //   title_page.push('<p class=\"source\"><Text>${token.text}</Text></p>')
      //   break
      // case 'notes':
      //   title_page.push('<p class=\"notes\"><Text>${token.text}</Text></p>')
      //   break
      // case 'draft_date':
      //   title_page.push('<p class=\"draft-date\"><Text>${token.text}</Text></p>')
      //   break
      // case 'date':
      //   title_page.push('<p class=\"date\"><Text>${token.text}</Text></p>')
      //   break
      // case 'contact':
      //   title_page.push('<p class=\"contact\"><Text>${token.text}</Text></p>')
      //   break
      // case 'copyright':
      //   title_page.push(`<p class="copyright"><Text>${token.text}</Text></p>`)
      //   break

      case 'scene_heading':
        xml.push(`<Paragraph Type="Scene Heading"${extraProps}>${token.text}</Paragraph>`)
        break
      // prose
      case 'sceneHeading':
        xml.push(`<Paragraph Type="Scene Heading"${extraProps}>${token.text}</Paragraph>`)
        break
      case 'transition':
        xml.push(`<Paragraph Type="Transition"${extraProps}>${token.text}</Paragraph>`)
        break
      case 'character':
        xml.push(`<Paragraph Type="Character"${extraProps}>${token.text}</Paragraph>`)
        break
      case 'parenthetical':
        xml.push(`<Paragraph Type="Parenthetical"${extraProps}>${token.text}</Paragraph>`)
        break
      case 'dual_dialogue_begin':
        xml.push('<Paragraph><DualDialogue>')
        break
      case 'dialogue':
        xml.push(`<Paragraph Type="Dialogue"${extraProps}>${token.text}</Paragraph>`)
        break
      case 'dual_dialogue_end':
        xml.push('</DualDialogue></Paragraph>')
        break
      case 'note':
        xml.push(`<Paragraph Type="General"><ScriptNote><Paragraph${extraProps}><Text>${token.text}</Text></Paragraph></ScriptNote></Paragraph>`)
        break
      case 'action':
        xml.push(`<Paragraph Type="Action"${extraProps}>${token.text}</Paragraph>`)
        break
      case 'general':
        xml.push(`<Paragraph Type="General"${extraProps}>${token.text}</Paragraph>`)
        break
      case 'new_act':
        xml.push(`<Paragraph Type="New Act"${extraProps}>${token.text}</Paragraph>`)
        break
      case 'end_of_act':
        xml.push(`<Paragraph Type="End of Act"${extraProps}>${token.text}</Paragraph>`)
        break
      case 'bracket':
        xml.push(`<Paragraph Type="General"${extraProps}>${token.text}</Paragraph>`)
        break
      case 'slug':
        xml.push(`<Paragraph Type="Transition"${extraProps}>${token.text}</Paragraph>`)
        break
      case 'centered':
        xml.push(`<Paragraph Type="General" Alignment="Center"${extraProps}>${token.text}</Paragraph>`)
        break
      default: // catch all to ensure new block types arent accidentally omitted entirely
        xml.push(`<Paragraph Type="General"${extraProps}>${token.text}</Paragraph>`)
        break
    }
  }

  xml.push('<?xml version="1.0" encoding="UTF-8" standalone="no" ?><FinalDraft DocumentType="Script" Template="No" Version="1"><Content>')

  return { fdx: xml.reverse().join('') }
}
module.exports = FDXconverter
